import { Component, OnDestroy, OnInit, Type } from "@angular/core";
import { switchMap, tap } from "rxjs/operators";
import { TemplateFacade } from "src/app/services/template.facade";
import { StepFacade } from "src/app/step/services/step.facade";
import { SubSink } from "subsink";
import { ICirculationTemplate } from "../../interfaces/circulation";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services/navigation.service";

@Component({
    selector: "circ-edit-step-template",
    templateUrl: "./edit-step.component.html",
    styleUrls: ["./edit-step.component.scss"],
    standalone: false
})
@LogClass({ source: "Templates/EditStepComponent" })
export class EditStepComponent implements OnInit, OnDestroy {
  public loading = true;
  public providerComponent: Type<unknown>;

  private template: ICirculationTemplate;
  private stepId: number;
  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private navigate: NavigationService,
    private templateFacade: TemplateFacade,
    private stepFacade: StepFacade
  ) {
    this.logger.debug("ctor");
  }

  public abort(): void {
    this.navigate.toCirculation(this.template.id);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.logger.info("init");

    this.templateFacade
      .getCurrentTemplate()
      .pipe(
        tap((template) => {
          this.template = template;
        }),
        switchMap((template) => this.templateFacade.getCurrentStep(template)),
        switchMap((step) => this.stepFacade.getStepType(step.payload.stepType))
      )
      .subscribe((stepType) => {
        this.logger.debug("showing edit-form for:" + stepType.name);
        this.providerComponent = stepType.editTemplateComponent;
        this.loading = false;
      });
  }
}
